export const ValidationCodes = {
  NHS: 'NHS',
};
